(function () {
  'use strict';

  var TRADE_FORM_ID = 'forms-root-1058787';
  var STYLE_ID = 'matho-trade-form-shadow-style';

  var shadowCss = `
    :host {
      --forms-base-font-size: calc(var(--font-body-scale, 1.1) * 1.4rem) !important;
      --forms-heading-font-size: 0px !important;

      --forms-body-font:
        var(--font-body-style, normal)
        var(--font-body-weight, 400)
        calc(var(--font-body-scale, 1.1) * 1.4rem)
        var(--font-body-family, Montserrat, sans-serif) !important;

      --forms-heading-font:
        var(--font-heading-style, normal)
        var(--font-heading-weight, 400)
        calc(var(--font-heading-scale, 1.15) * 3.6rem)
        var(--font-heading-family, Chivo, sans-serif) !important;

      --form-background-color: transparent !important;
      --container-background-color: transparent !important;
      --container-shadow: none !important;

      --container-max-w: 100% !important;
      --inline-container-max-width: 100% !important;
      --inline-container-min-height: auto !important;

      --forms-padding-top: 0px !important;
      --forms-padding-right: 0px !important;
      --forms-padding-bottom: 0px !important;
      --forms-padding-left: 0px !important;

      --app-embed-padding-y: 0px !important;
      --app-embed-padding-x: 0px !important;

      --form-field-border-radius: var(--input-border-radius, 0px) !important;
      --button-border-radius: var(--button-border-radius, 0px) !important;

      --button-background-color: rgb(var(--color-filled-button, 20, 20, 20)) !important;
      --button-text-color: rgb(var(--color-filled-button-text, 243, 242, 236)) !important;

      --body-text-color: rgb(var(--color-foreground, 20, 20, 20)) !important;
      --heading-text-color: rgb(var(--color-heading-text, 20, 20, 20)) !important;
      --form-text-color: rgb(var(--color-heading-text, 20, 20, 20)) !important;
      --form-placeholder-color: rgba(var(--color-foreground, 20, 20, 20), 0.45) !important;

      --form-field-border: 0 0 0 1px rgba(var(--color-border, 204, 203, 198), var(--alpha-border, 1)) !important;
      --form-field-border-focused: 0 0 0 1px rgb(var(--color-foreground, 20, 20, 20)) !important;
      --button-border: 1px solid rgb(var(--color-filled-button, 20, 20, 20)) !important;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box !important;
    }

    /* Remove Shopify Forms default top spacing */
    ._appEmbedRoot_1d2l7_9,
    ._appEmbed_3eyaa_1,
    ._container_3eyaa_70,
    #form-container-ref,
    ._inline_1q1d2_47,
    ._formContainer_1q1d2_30,
    ._grid_1q1d2_148,
    ._gridItem_1q1d2_172,
    ._gridItemContent_1q1d2_257,
    section,
    form {
      margin-top: 0 !important;
      padding-top: 0 !important;
      min-height: auto !important;
    }

    /* Hide default Shopify Forms heading and description */
    ._formHeader_cit2d_24,
    ._textHeading_2aowh_35,
    ._formHeader_cit2d_24 ._textBody_2aowh_10,
    ._formHeader_cit2d_24 p {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      max-height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    /* Center whole form and make it 50% width on desktop */
    ._formContainer_1q1d2_30,
    ._grid_1q1d2_148,
    ._gridItemContent_1q1d2_257 {
      width: 100% !important;
      max-width: 100% !important;
      background: transparent !important;
      box-shadow: none !important;
      border: 0 !important;
    }

    ._gridItemContent_1q1d2_257 {
      display: block !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    /* Main form: 50% width, centered, one field per row */
    form,
    ._formFieldset_cit2d_82,
    [data-testid='form'] {
      display: grid !important;
      grid-template-columns: 1fr !important;
      row-gap: 1.6rem !important;
      column-gap: 0 !important;

      width: 50% !important;
      max-width: 72rem !important;
      min-width: 42rem !important;

      margin: 0 auto !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    ._formFieldset_cit2d_82 > *,
    [data-testid='form'] > * {
      grid-column: 1 / -1 !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
    }

    /* Hide invisible lead capture wrapper spacing */
    ._formFieldset_cit2d_82 > div:first-child,
    [data-testid='form'] > div:first-child {
      display: none !important;
      height: 0 !important;
      min-height: 0 !important;
      max-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }

    /* Field containers */
    ._formFieldContainer_1mxsl_5 {
      display: flex !important;
      flex-direction: column-reverse !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    ._formPhoneInputContainer_piv1u_6,
    ._selectContainer_12thd_6,
    ._formFileInput_ehvsf_1,
    ._checkboxFieldSet_1hja3_3 {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    /* Labels above fields */
    ._formInputFieldLabel_1mxsl_38,
    ._label_12thd_10,
    ._formFileInput_ehvsf_1 > p,
    ._checkboxLegend_1hja3_20 {
      position: static !important;
      display: block !important;
      transform: none !important;
      top: auto !important;
      left: auto !important;

      margin: 0 0 0.8rem !important;
      padding: 0 !important;

      color: rgb(var(--color-foreground, 20, 20, 20)) !important;
      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: var(--font-size-static-xs, 1.1rem) !important;
      line-height: var(--line-height-static-sm, 1.2) !important;
      font-weight: var(--font-weight-medium, 500) !important;
      letter-spacing: 0.1rem !important;
      text-transform: uppercase !important;
      pointer-events: auto !important;
    }

    /* Inputs like Forest theme contact form */
    ._formInputField_nag3b_7,
    ._formPhoneInputField_piv1u_17,
    ._selectToggle_12thd_25,
    ._formFileInputField_ehvsf_5 {
      width: 100% !important;
      min-height: 4.8rem !important;
      height: 4.8rem !important;

      padding: 0 1.6rem !important;

      border: 0.1rem solid rgba(var(--color-border, 204, 203, 198), var(--alpha-border, 1)) !important;
      border-radius: var(--input-border-radius, 0px) !important;

      background: transparent !important;
      color: rgb(var(--color-heading-text, 20, 20, 20)) !important;

      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1.1) * 1.4rem) !important;
      font-style: var(--font-body-style, normal) !important;
      font-weight: var(--font-body-weight, 400) !important;
      line-height: calc(1 + .6 / var(--font-body-scale, 1.1)) !important;

      box-shadow: none !important;
      outline: none !important;
    }

    ._formInputField_nag3b_7:focus,
    ._formPhoneInputField_piv1u_17:focus,
    ._selectToggle_12thd_25:focus,
    ._formFileInputField_ehvsf_5:focus {
      border-color: rgb(var(--color-foreground, 20, 20, 20)) !important;
      box-shadow: none !important;
      outline: none !important;
    }

    /* Phone field: keep country selector + phone input in same row */
    ._formPhoneInputContainer_piv1u_6 {
      display: grid !important;
      grid-template-columns: 8rem minmax(0, 1fr) !important;
      column-gap: 1.2rem !important;
      align-items: end !important;
    }

    ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
      display: flex !important;
      flex-direction: column-reverse !important;
    }

    .phone-country-selector {
      width: 8rem !important;
    }

    .phone-country-selector ._selectContainer_12thd_6 {
      margin: 0 !important;
    }

    .phone-country-selector ._selectToggle_12thd_25 {
      justify-content: center !important;
      padding: 0 1rem !important;
    }

    /* Select field */
    ._selectToggle_12thd_25 {
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      cursor: pointer !important;
    }

    ._selectToggleText_12thd_25 {
      color: rgb(var(--color-heading-text, 20, 20, 20)) !important;
      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1.1) * 1.4rem) !important;
    }

    /* File upload field */
    ._formFileInputField_ehvsf_5 {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      cursor: pointer !important;
    }

    ._formFileInputButton_ehvsf_18 {
      margin: 0 !important;
      color: rgb(var(--color-heading-text, 20, 20, 20)) !important;
      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1.1) * 1.4rem) !important;
      font-weight: var(--font-body-weight, 400) !important;
    }

    /* Checkbox area */
    ._checkboxFieldSet_1hja3_3 {
      border: 0 !important;
    }

    ._verticalLayout_1hja3_8 {
      display: grid !important;
      gap: 1.2rem !important;
    }

    ._checkboxField_1hja3_3 {
      display: flex !important;
      align-items: flex-start !important;
      gap: 1rem !important;
      color: rgb(var(--color-foreground, 20, 20, 20)) !important;
      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: calc(var(--font-body-scale, 1.1) * 1.4rem) !important;
      line-height: calc(1 + .6 / var(--font-body-scale, 1.1)) !important;
    }

    ._checkboxWrapper_1hja3_33 {
      flex: 0 0 auto !important;
    }

    ._checkboxInput_1hja3_38 {
      accent-color: rgb(var(--color-foreground, 20, 20, 20)) !important;
      margin-top: 0.2rem !important;
    }

    /* Submit button like theme button */
    ._formSubmitButton_cit2d_96,
    button[type='submit'] {
      display: inline-block !important;
      width: auto !important;
      min-width: 14rem !important;
      min-height: 4.8rem !important;

      padding: 1.6rem 2.4rem !important;

      border-radius: var(--button-border-radius, 0px) !important;
      border: 0.1rem solid rgb(var(--color-filled-button, 20, 20, 20)) !important;

      background-color: rgb(var(--color-filled-button, 20, 20, 20)) !important;
      color: rgb(var(--color-filled-button-text, 243, 242, 236)) !important;

      font-family: var(--font-button-family, Chivo, sans-serif) !important;
      font-size: calc(var(--font-button-scale, 1) * 1rem) !important;
      line-height: calc(1 + 0 / var(--font-button-scale, 1)) !important;
      font-weight: var(--font-button-weight, 400) !important;
      letter-spacing: var(--font-button-letter-spacing, 0.1em) !important;
      text-transform: uppercase !important;
      text-align: center !important;

      cursor: pointer !important;
      box-shadow: none !important;
    }

    ._formSubmitButton_cit2d_96:hover,
    button[type='submit']:hover {
      background-color: transparent !important;
      color: rgb(var(--color-filled-button, 20, 20, 20)) !important;
      border-color: rgb(var(--color-filled-button, 20, 20, 20)) !important;
    }

    /* Disclaimer */
    ._formDisclaimer_cit2d_38 {
      width: 50% !important;
      max-width: 72rem !important;
      min-width: 42rem !important;

      margin: 1.6rem auto 0 !important;
      padding: 0 !important;

      color: rgba(var(--color-foreground, 20, 20, 20), 0.7) !important;
      font-family: var(--font-body-family, Montserrat, sans-serif) !important;
      font-size: 1.2rem !important;
      line-height: 1.5 !important;
      text-align: left !important;
    }

    ._formDisclaimer_cit2d_38 p {
      margin: 0 !important;
    }

    /* Mobile: full width */
    @media screen and (max-width: 749px) {
      form,
      ._formFieldset_cit2d_82,
      [data-testid='form'],
      ._formDisclaimer_cit2d_38 {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      ._formPhoneInputContainer_piv1u_6 {
        grid-template-columns: 8rem minmax(0, 1fr) !important;
      }

      ._formSubmitButton_cit2d_96,
      button[type='submit'] {
        width: 100% !important;
      }
    }
  `;

  function injectTradeFormStyle() {
    var root = document.querySelector('[data-forms-id="' + TRADE_FORM_ID + '"]');

    if (!root) {
      return false;
    }

    root.classList.add('matho-trade-form-ready');

    var section = root.closest('[id^="shopify-section-"]');

    if (section) {
      section.classList.add('matho-trade-form-section');

      var directDiv = section.querySelector(':scope > div');
      if (directDiv) {
        directDiv.style.paddingTop = '0';
        directDiv.style.paddingBlockStart = '0';
      }
    }

    var appEmbeds = root.closest('.app-embeds');
    if (appEmbeds) {
      appEmbeds.style.paddingTop = '0';
      appEmbeds.style.paddingBlockStart = '0';
    }

    var embed = root.querySelector('shopify-forms-embed');

    if (!embed || !embed.shadowRoot) {
      return false;
    }

    if (!embed.shadowRoot.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = shadowCss;
      embed.shadowRoot.appendChild(style);
    }

    return true;
  }

  function startTradeFormWatcher() {
    injectTradeFormStyle();

    var tries = 0;

    var interval = window.setInterval(function () {
      tries += 1;

      var done = injectTradeFormStyle();

      if (done || tries > 100) {
        window.clearInterval(interval);
      }
    }, 250);

    var observer = new MutationObserver(function () {
      injectTradeFormStyle();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startTradeFormWatcher);
  } else {
    startTradeFormWatcher();
  }
})();